import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';

import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper'
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';

import { getIsHeaderNavDisplayed } from 'cityads-v3/reducers/header';

import classes from './HeaderNav.scss';

const tabLinkComponent = forwardRef((props, ref) =>
  <Link style={{ textDecoration: 'none' }} {...props} ref={ref} />
)

@connect(
  state => ({
    title: state.header.title,

    backlink    : state.header.backlink,
    backlinkText: state.header.backlinkText,

    menu     : state.header.menu,
    menuShow : state.header.menuShow,
    menuValue: state.header.menuValue,

    menuDocked: state.menu.docked,

    isMobile: state.app.isMobile,

    isLoggedIn: state.auth.isLoggedIn,
  })
)
export default class HeaderNav extends Component {

  static propTypes = {
    title: PropTypes.string,

    backlink    : PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        pathname: PropTypes.string,
      }),
    ]),
    backlinkText: PropTypes.string,

    menu     : PropTypes.array,
    menuShow : PropTypes.bool,
    menuValue: PropTypes.any,

    menuDocked: PropTypes.bool,

    isMobile: PropTypes.bool,

    isLoggedIn: PropTypes.bool,
  }

  handleTabChange = (event, value) => {
    const { menu, onMenuChange } = this.props;
    const item = menu.filter(item => item.id === value);
    if (item.route && onMenuChange) {
      this.props.onMenuChange(value, item.route)
    }
  }

  renderMenu() {
    if (!this.props.menuShow || !this.props.menu || !this.props.menu.length) {
      return null;
    }

    const { location } = this.props;

    return (
      <Tabs
        value          = {this.props.menuValue}
        onChange       = {this.handleTabChange}
        indicatorColor = "primary"
        textColor      = "primary"
        variant        = {this.props.isMobile ? 'scrollable' : 'standard'}
        classes        = {{
          root: classes.tabs
        }}
      >
        {this.props.menu.map(item => (
          <Tab
            key       = {item.id}
            label     = {item.title + (item.total ? ' (' + item.total + ')' : '')}
            value     = {item.id}
            to        = {item.onlyPathname ? {...location, pathname: item.route} : item.route}
            component = {item.route ? tabLinkComponent : undefined}
            classes   = {{ root: classes.tab }}
          />
        ))}
      </Tabs>
    );
  }

  getBackLink(props, ref) {
    const { children, location, ...rest } = props;

    return <Link to={location} {...rest} ref={ref}>{children}</Link>;
  }

  renderBacklink() {
    const { backlink, backlinkText } = this.props;

    if (!backlink) {
      return <div className={classes.backlink__empty}></div>;
    }

    return (
      <Tooltip title={backlinkText}>
        <IconButton
          location={backlink}
          component={forwardRef(this.getBackLink)}
          className={classes.backlink}
        >
          <ArrowBackOutlinedIcon />
        </IconButton>
      </Tooltip>
    );
  }

  render() {
    const { title, backlink, menuShow, menu, menuDocked, isMobile, isLoggedIn } = this.props;
    const showNav = getIsHeaderNavDisplayed({ title, menuShow, menu, backlink });

    return showNav ? (
      <Paper square className={classNames(classes.headerNav, {
        [classes.headerNavDocked]: menuDocked && !isMobile,
        [classes.headerNavMobile]: isMobile || (!isMobile && !isLoggedIn)
      })}>
        {this.renderBacklink()}

        {title && (
          <Typography
            color="textPrimary"
            variant="h1"
            className={classNames({
              [classes.headerNav__title]: true,
              [classes.headerNav__title_wo_backlink]: !backlink
            })}
          >
            {title}
          </Typography>
        )}

        {this.renderMenu()}
      </Paper>
    ) : false;
  }
}
